// extracted by mini-css-extract-plugin
export var menuItem = "Y_yt d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "Y_yv d_Z d_bz d_bP";
export var menuMainLink = "Y_yw d_f0 d_dB";
export var menuLink = "Y_yx d_f0 d_dB";
export var icon = "Y_n9 d_bC d_bP";
export var divider = "Y_yy d_bC d_bP";
export var sublinks = "Y_yz";
export var link = "Y_mZ";
export var Link = "Y_wc K_wc K_vB K_vW";